import { convertMinToDayHourMin } from './helpers/convertMinToDayHourMin';
import { ReportColumnConfig } from 'components/ReportGrid_New/types';


const formatAverageDuration = (value: string | number | Date) => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return `Average Duration:\n${value}`;
  }

  return `Average Duration:\n${convertMinToDayHourMin(value, 'S')}`;
};

export const SLA_PERFORMANCE_REPORT ="SLA Performance V3 Report"
export const SLA_PERFORMANCE_INFO_MESSAGE ="Allows a detailed analysis of SLA Performance."
export const SLA_PERFORMANCE_TITLE = "SLAPerformanceV3";

export const columns: ReportColumnConfig[] = [
  { name: 'repairerGroup', title: 'Repairer Group', groupIndex: 1 },
  { name: 'repairCode', title: 'Repair Code' },
  { name: 'regMark', title: 'Registration' },
  { name: 'repairerName', title: 'Repairer Name', groupIndex: 2 },
  { name: 'claimReference', title: 'Claim Reference' },
  { name: 'startDTG', title: 'SLA Start', type: 'date' },
  { name: 'expectedDataValue', title: 'SLA Expected End', type: 'date' },
  { name: 'actualDataValue', title: 'SLA Actual End', type: 'date' },
  {
    name: 'slaDuration',
    title: 'Duration',
  },
    {
    name: 'slaDurationConverted',   // we use converted values to display on the table, we still keep data from backend to handle AVG grouping correctly 
    title: 'Duration NEW',
  },

  { name: 'hashtag', title: 'Hashtag' },
  {
    name: 'slaTitle',
    title: 'SLA Title',
    groupIndex: 0,
  },
  {
    name: 'passed',
    title: 'Passed',
  },
  { name: 'stream', title: 'Stream' },
  { name: 'slaBreach', visible: false}
];

export const summaryItems = [
  {
    columnName: 'claimReference',
    type: 'count',
    customizeText: ({ value }: { value: string | number | Date }) =>
      `Total Claims: ${value}`,
  },
  { name: 'startDTG', showInColumn: 'startDTG', type: 'custom', customizeText: ({ value }: { value: string | number | Date }) =>
      `SLA Compliance: ${value}`, },
  {
    name: 'slaDurationConverted',
    showInColumn: 'slaDurationConverted',
    type: 'custom',
    customizeText: ({ value }: { value: string | number | Date }) =>
      formatAverageDuration(value),
  },
];

export const groupSummaryItems = [
  {
    name: 'startDTG',
        showInColumn: 'startDTG',

    type: 'custom',
    showInGroupFooter: false,
    alignByColumn: true,
    customizeText: ({ value }: { value: string | number | Date }) =>
      `SLA Compliance:\n${value}`
  },
  {
    name: 'slaDurationConverted',
    showInColumn: 'slaDurationConverted',
    type: 'custom',
    showInGroupFooter: false,
    alignByColumn: true,
    customizeText: ({value}: {value: string | number | Date}) => formatAverageDuration(value),
  },
  {
    name: 'expectedDataValue',
    showInColumn: 'expectedDataValue',
    type: 'custom',
    showInGroupFooter: false,
    alignByColumn: true,
    customizeText: ({ value }: { value : any }) =>
     value.shouldDisplay ? `${getExpectedDataValueText(value)}` : '', 
  },
];

const getExpectedDataValueText = (value: any) => {
  return `${value.onTime}% On Time\n${value.early}% Early\n${value.late}% Late\n${value.notSet}% Not Set`;
}
